module.exports = __webpack_public_path__ + "static/media/blank.75f97e04.png";